/**
 * =============================================================================
 * ************   JavaScript 工具库，语法和 jQuery 类似   ************
 * =============================================================================
 */
/* jshint ignore:start */
var $ = (function (window, document, undefined) {
  'use strict';
/* jshint ignore:end */
